module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-2.6e388804.jpg";